package com.anjuros.website.redesign.sections.seo

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.RdIncludedStyle
import com.anjuros.website.redesign.styles.SeoDefineGridStyle
import com.anjuros.website.redesign.styles.SeoDefineTextStyle
import com.anjuros.website.redesign.styles.SeoTermStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** Pale-blue band explaining what SEO means, styled like a dictionary entry. */
@Composable
fun SeoDefinitionSection() {
    RdSection(labelledBy = "define-h", modifier = RdIncludedStyle.toModifier(), wrapModifier = SeoDefineGridStyle.toModifier()) {
        P(SeoTermStyle.toModifier().toAttrs()) {
            B { Text(LocalText(RdText.SEO_TERM)) }
            Span { Text(LocalText(RdText.SEO_TERM_FULL)) }
        }
        Div(SeoDefineTextStyle.toModifier().toAttrs()) {
            H2({ id("define-h") }) { Text(LocalText(RdText.SEO_DEFINE_TITLE)) }
            P { Text(LocalText(RdText.SEO_DEFINE_TEXT)) }
        }
    }
}
